module.exports = __webpack_public_path__ + "static/media/Codniv_logo.fef1d101.png";